import { ReactNode } from 'react';

export enum AnalyticsMenuItems {
  NONE = 'job',
  JOB_ANALYTICS = 'job',
  MAPPINGS = 'mappings',
  SUBMISSIONS = 'submissions',
  TASK_ANALYTICS = 'task',
  LEADERBOARDS = 'leaderboards',
  LOGIN_ACTIVITY = 'login-activity',
  COMMUNICATION_ANALYTICS = 'communication',
  CAREER_PAGES = 'career-pages',
  MASS_MAILING = 'mass-mailing',
  CLIENT_RELATIONS = 'client-relations',
  AI_AND_AUTOMATION = 'ai-and-automation',
  BOT_ANALYTICS = 'bot',
  CV_UPLOAD = 'cv-upload',
  CV_VIEW = 'cv-views',
  YOUR_DASHBOARDS = 'your-dashboards',
  YOUR_DASHBOARDS_COLLECTIONS = 'master-dashboards',
}

export interface IAnalyticsMenuOption {
  id?: string;
  icon?: ReactNode;
  label: string;
  url: string;
  description?: string;
  caption?: string;
  createdByName?: string;
  openInNewTab?: boolean;
  state?: Record<string, any>;
  createdOn?: string;
  modifiedOn?: string;
  showKebabMenu?: boolean;
  kebabMenuOptions?: IKebabMenuOption[];
}

export interface IKebabMenuOption {
  text: string;
  onClick: (index: number) => void;
  icon?: ReactNode;
}

export interface IReactGridLayout {
  x: number;
  y: number;
  w: number;
  h: number;
  i: string;
  minW?: number;
  minH?: number;
  maxW?: number;
  maxH?: number;
}
